import React, { useState } from 'react';
import { PeekDialogContent, PeekDialogContentText, PeekTextField, PeekDialogActions, PeekButton } from '@piiqtechnologies/ui-components';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../../../../utils/ErrorProvider.js';
import '../../../../../utils/LoaderProvider.js';
import '../../../../../utils/RefetchProvider.js';
import '../../../../../utils/NotificationProvider.js';
import 'tslib';
import { getUniqueTimeStampId } from '../../../../../utils/getUniqueId.js';
import '../../../../../utils/ContactProvider.js';
import '../../../../../utils/PolicyProvider.js';
import '../../../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import '../../../../../utils/analyticsPlugin.js';
import '../../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../../utils/cookieUtils.js';
import '../../../../../utils/termsConditionsAgreementsUtils.js';

const InfoHotspot = ({ onHotspotCreation, onCloseModal }) => {
    const [name, setName] = useState("");
    const onChangeName = (event) => {
        setName(event.target.value);
    };
    const createInfoSpot = () => {
        const infospot = {
            _id: getUniqueTimeStampId("hotspot"),
            text: name,
            rotation: {
                pitch: 0,
                yaw: 0,
            },
        };
        onHotspotCreation(infospot);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekDialogContent, null,
            React.createElement(PeekDialogContentText, { color: "text.primary" }, "Add InfoSpot Text"),
            React.createElement(PeekTextField, { variant: "standard", fullWidth: true, multiline: true, rows: 4, value: name, onChange: onChangeName, InputProps: {
                    disableUnderline: true,
                    "aria-label": "Info Hotspot Text",
                } })),
        React.createElement(PeekDialogActions, null,
            React.createElement(PeekButton, { onClick: onCloseModal, color: "secondary", variant: "outlined" }, "Cancel"),
            React.createElement(PeekButton, { onClick: createInfoSpot, color: "secondary", variant: "contained" }, "Save"))));
};

export { InfoHotspot, InfoHotspot as default };
